// BookingTimerContext.tsx
import React, { createContext, useContext, useState, useEffect } from 'react';

interface TimerContextProps {
  timeLeft: number;
  startTimer: (seconds?: number) => void;
  resetTimer: () => void;
}

const BookingTimerContext = createContext<TimerContextProps | undefined>(
  undefined
);

export const BookingTimerProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const queryParams = new URLSearchParams(window.location.search);
  const locationCode = queryParams.get('locationCode');
  const [timeLeft, setTimeLeft] = useState(0);
  const [timerId, setTimerId] = useState<number | null>(null);

  const clearTimer = () => {
    if (timerId) {
      clearInterval(timerId);
      setTimerId(null);
    }
  };

  const startTimer = (seconds: number = 600) => {
    clearTimer();
    setTimeLeft(seconds);

    const id = window.setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          if (timeLeft === 0) {
            clearInterval(id);
            window.location.replace(
              `${locationCode ? '/?locationCode=' + locationCode : '/'}`
            );
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    setTimerId(id);
  };
  const resetTimer = () => startTimer();

  useEffect(() => clearTimer, []); // cleanup on unmount

  return (
    <BookingTimerContext.Provider value={{ timeLeft, startTimer, resetTimer }}>
      {children}
    </BookingTimerContext.Provider>
  );
};

export const useBookingTimer = () => {
  const ctx = useContext(BookingTimerContext);
  if (!ctx)
    throw new Error('useBookingTimer must be used within BookingTimerProvider');
  return ctx;
};
